import { useEffect } from 'react';

const Toast = ({ message, type = 'success', show, onHide, durationMs }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onHide();
      }, durationMs || 3000);

      return () => clearTimeout(timer);
    }
  }, [show, onHide, durationMs]);

  if (!show) return null;

  return (
    <div className={`toast ${type} ${show ? 'show' : ''}`}>
      {message}
    </div>
  );
};

export default Toast; 